import { create } from 'zustand'
import type { IncidentPriority, IncidentStatus } from '../types/incident.types'

interface IncidentsFilterStore {
  priorities: IncidentPriority[]
  statuses: IncidentStatus[]
  setPriorities: (priorities: IncidentPriority[]) => void
  setStatuses: (statuses: IncidentStatus[]) => void
  clearFilters: () => void
}

export const useIncidentsFilterStore = create<IncidentsFilterStore>((set) => ({
  priorities: [],
  statuses: [],
  setPriorities: (priorities) => set({ priorities }),
  setStatuses: (statuses) => set({ statuses }),
  clearFilters: () => set({ priorities: [], statuses: [] }),
}))
